import { OrderSide } from 'communication/types/order/OrderSide';
import { AggregatedOpenSubmissions } from 'widgets/openSubmissions/hooks';
import { getSideClass } from 'utils/css/cssUtils';
import { DoughnutChartSeriesItem } from 'utils/components/DoughnutChart/DoughnutChart';
import classNames from 'classnames';
import { NumberFormat, textUtils } from '@instinet-analytics/core-lib';

const { pluralise } = textUtils;

export const filledWidth = 12;
export const exposedWidth = 7;
export const conditionalWidth = 3;

export const createDoughnutSeries = (
    side: OrderSide,
    {
        filled,
        litOrExchange,
        siOrSdp,
        dark,
        alternativeOrPeriodic,
        other,
        conditional,
        remaining,
        totalQuantity,
        percentageComplete,
    }: AggregatedOpenSubmissions,
    numberFormat: NumberFormat
): DoughnutChartSeriesItem[] => {
    const createExposedTooltip = (value: number) => ({
        body: `${numberFormat.n0(value)} ${pluralise(value, 'share')} exposed`,
    });

    return [
        {
            value: filled,
            segmentWidth: filledWidth,
            classname: classNames('filled', getSideClass(side)),
            id: 'filled',
            tooltip: {
                body: `${numberFormat.n0(filled)} ${pluralise(
                    filled,
                    'share'
                )} ${side === 'B' ? 'bought' : 'sold'} of ${numberFormat.n0(
                    totalQuantity
                )} (${numberFormat.n0(percentageComplete)}% Complete)`,
            },
        },
        {
            value: litOrExchange,
            segmentWidth: exposedWidth,
            classname: 'litOrExchange',
            id: 'litOrExchange',
            tooltip: createExposedTooltip(litOrExchange),
        },
        {
            value: siOrSdp,
            segmentWidth: exposedWidth,
            classname: 'siOrSdp',
            id: 'siOrSdp',
            tooltip: createExposedTooltip(siOrSdp),
        },
        {
            value: alternativeOrPeriodic,
            segmentWidth: exposedWidth,
            classname: 'alternativeOrPeriodic',
            id: 'alternativeOrPeriodic',
            tooltip: createExposedTooltip(alternativeOrPeriodic),
        },
        {
            value: dark,
            segmentWidth: exposedWidth,
            classname: 'dark',
            id: 'dark',
            tooltip: createExposedTooltip(dark),
        },
        {
            value: other,
            segmentWidth: exposedWidth,
            classname: 'other',
            id: 'other',
            tooltip: createExposedTooltip(other),
        },
        {
            value: conditional,
            segmentWidth: conditionalWidth,
            classname: 'conditional',
            id: 'conditional',
            tooltip: createExposedTooltip(conditional),
        },
        {
            value: remaining,
            segmentWidth: 1,
            classname: 'remaining',
            id: 'remaining',
        },
    ];
};
